import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Dictionary } from '../../../domain/dictionary.model';

@Injectable()
export class DictionaryService {

    constructor(private store: Store, private http: HttpClient) {
    }

    download(codes: string[]): Observable<Dictionary[]> {
        const params = new HttpParams().set('code', codes.join(','));
        return this.http.get<Dictionary[]>('/api/secured/dictionary', {params});
    }

}
